import FormatService from "services/formatService";
import { PricingLookupStyle } from "./style";

export const PricingLookupMenuItem = ({ value, isBundle }) => {
    const classes = PricingLookupStyle();

    return (
        <div className={classes.pricingDetails}>
            {!isBundle && <div className={classes.pricingLine}>
                <span className={classes.pricingLabel}>Vendor</span>
                <span className={classes.pricingValue}>{value.vendor || '-'}</span>
            </div>}
            {!isBundle && <div className={classes.pricingLine}>
                <span className={classes.pricingLabel}>Price</span>
                <span className={classes.pricingValue}>{value.formattedPrice}</span>
            </div>}
            {value.materialsCost ? (
                <div className={classes.pricingLine}>
                    <span className={classes.pricingLabel}>Materials Cost</span>
                    <span className={classes.pricingValue}>{FormatService.formatCurrency(value.materialsCost)}</span>
                </div>
            ) : null}
            <div className={classes.pricingLine}>
                <span className={classes.pricingLabel}>Charge</span>
                <span className={classes.pricingValue}>{value.formattedCharge}</span>
            </div>
        </div>
    );
};
